import { render, staticRenderFns } from "./MetadataInfo.vue?vue&type=template&id=920b8924&scoped=true"
import script from "./MetadataInfo.vue?vue&type=script&lang=js"
export * from "./MetadataInfo.vue?vue&type=script&lang=js"
import style0 from "./MetadataInfo.vue?vue&type=style&index=0&id=920b8924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920b8924",
  null
  
)

export default component.exports